import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../styles/logo.png';
import '../styles/LegalPage.css';

const AGB = () => {
  return (
    <div className="legal-page">
      {/* Header */}
      <header className="legal-header">
        <div className="legal-container">
          <Link to="/" className="legal-logo">
            <img src={logoImage} alt="maiave Logo" className="legal-logo-image" />
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="legal-content">
        <div className="legal-container">
          <h1 className="legal-title">Allgemeine Geschäftsbedingungen</h1>
          
          {/* 👇 HIER DEINEN INHALT EINFÜGEN */}
          <div className="legal-text">
            <h2>Angaben gemäß § 5 TMG</h2>
            <p>
              [Dein Name / Firmenname]<br />
              [Straße und Hausnummer]<br />
              [PLZ und Ort]
            </p>

            <h2>Kontakt</h2>
            <p>
              Telefon: [Deine Telefonnummer]<br />
              E-Mail: [Deine E-Mail]
            </p>

            <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              [Dein Name]<br />
              [Deine Adresse]
            </p>

            <h2>EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>

            {/* Platzhalter für weitere Inhalte */}
          </div>
          {/* 👆 BIS HIER */}

          {/* Back Button */}
          <div className="legal-back">
            <Link to="/" className="legal-back-button">
              ← Zurück zur Startseite
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="legal-footer">
        <div className="legal-container">
          <p>&copy; 2024 maiave. Alle Rechte vorbehalten.</p>
        </div>
      </footer>
    </div>
  );
};

export default AGB;